import { request } from 'shared/helpers/sagas'

export function checkForNoShows () {
    return request('/v1/selfservice/noshow')
  }
  
export function markNoShow ({ noShow, projectId, timeSlotId }) {
    return request(`/v1/selfservice/project/${projectId}/timeslot/${timeSlotId}`,
      'PUT',
      { noShow }
    )
  }

export default {
    checkForNoShows,
    markNoShow
}